import React from "react";
import { Link } from "react-router-dom";

const UsefulLinks = () => {
  return (
    <>
      <div className="col-12 col-sm-12 col-md-6 col-lg-3">
        <div className="about-rct-sec blue-box">
          <div className="about-links">
            <div className="titlesec">
              <h4 className="httxt">E-Court</h4>
            </div>
            <div className="title-links">
              <ul>
                <li>
                  <a
                    href="https://efiling.erct.gov.in/#/"
                    target="_blank"
                    className="lnk-arrow"
                  >
                    E-Filing
                    <i className="fa-solid fa-chevron-right"></i>
                  </a>
                </li>
                <li>
                  <Link to={"help-desk"} className="lnk-arrow">
                    Help Desk
                    <i className="fa-solid fa-chevron-right"></i>
                  </Link>
                </li>
                <li>
                  <a
                    href="https://cis.erct.gov.in/#/"
                    target="_blank"
                    className="lnk-arrow"
                  >
                    CIS
                    <i className="fa-solid fa-chevron-right"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://cis.erct.gov.in/#/display-board"
                    target="_blank"
                    className="lnk-arrow"
                  >
                    Display Board
                    <i className="fa-solid fa-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="important-links">
            <div className="titlesec">
              <h4 className="httxt">Useful Links</h4>
            </div>
            <div className="title-links">
              <ul>
                <li>
                  <Link to="tenders" className="lnk-arrow">
                    Tender / Notices
                    <i className="fa-solid fa-chevron-right"></i>
                  </Link>
                </li>
                <li>
                  <Link to="vacancies" className="lnk-arrow">
                    Vacancies<i className="fa-solid fa-chevron-right"></i>
                  </Link>
                </li>
                <li>
                  <Link to={"photos-gallery"} className="lnk-arrow">
                    Photo Gallery
                    <i className="fa-solid fa-chevron-right"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="important-links">
            <div className="titlesec">
              <h4 className="httxt">Important Links</h4>
            </div>
            <div className="title-links">
              <ul>
                <li>
                  <Link to="court-links" className="lnk-arrow">
                    Important High Court Links
                    <i className="fa-solid fa-chevron-right"></i>
                  </Link>
                </li>

                <li>
                  <a
                    href="https://www.sci.gov.in/"
                    target="_blank"
                    className="lnk-arrow"
                  >
                    Supreme Court Link
                    <i className="fa-solid fa-chevron-right"></i>
                  </a>
                </li>
                <li>
                  <Link to="other-links" className="lnk-arrow">
                    Railway Links
                    <i className="fa-solid fa-chevron-right"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UsefulLinks;
